export default __webpack_public_path__ + "static/media/jessica-1199x1199.4f7d97c9.webp";